import React from 'react'
import CurrencyFormat from 'react-currency-format'
import oxxoImage from '../../../assets/images/oxxo.png'

const OxxoReceiptComponent = ({
  data
}) => {
  console.log('data')
  console.log(data)
  return (
    <React.Fragment>
      <div className="opps">
        <div className="opps-header">
          <div className="opps-reminder">Ficha digital. No es necesario imprimir.</div>
          <div className="opps-info">
            <div className="opps-brand">
              <img
                src={oxxoImage}
                className="opps-img"
                alt="OXXOPay" />
            </div>
            <div className="opps-ammount">
              <h3 style={{
                marginBottom: '10px',
                fontSize: '15px',
                fontWeight: 600,
                textTransform: 'uppercase',
              }}>
                Monto a pagar
              </h3>
              <h2>
                <CurrencyFormat
                    value={data.amount / 100}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                />
                <sup>{data.currency}</sup>
              </h2>
              <p>OXXO cobrará una comisión adicional al momento de realizar el pago.</p>
            </div>
          </div>
          <div className="opps-reference">
            <h3>Referencia</h3>
            <h1 style={{
              fontSize: '27px',
              color: '#000000',
              textAlign: 'center',
              marginTop: '-1px',
              padding: '6px 0 7px',
              border: '1px solid #b0afb5',
              borderRadius: '4px',
              background: '#f8f9fa',
            }}>{data.charges.data[0].payment_method.reference}</h1>
          </div>
        </div>
        <div className="opps-instructions">
          <h3>Instrucciones</h3>
          <ol>
            <li style={{ marginTop: '10px', color: '#000000' }}>Acude a la tienda OXXO más cercana. <a style={{ color: '#1155cc' }} href="https://www.google.com.mx/maps/search/oxxo/" target="_blank" rel="noopener noreferrer">Encuéntrala aquí</a>.</li>
            <li style={{ marginTop: '10px', color: '#000000' }}>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li>
            <li style={{ marginTop: '10px', color: '#000000' }}>Dicta al cajero el número de referencia en esta ficha para que tecleé directamete en la pantalla de venta.</li>
            <li style={{ marginTop: '10px', color: '#000000' }}>Realiza el pago correspondiente con dinero en efectivo.</li>
            <li style={{ marginTop: '10px', color: '#000000' }}>Al confirmar tu pago, el cajero te entregará un comprobante impreso. <strong>En el podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de pago.</li>
          </ol>
          <div className="opps-footnote">Al completar estos pasos recibirás un correo de <strong>Vendora</strong> confirmando tu pago.</div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default OxxoReceiptComponent
